import { lazy, Suspense } from "react";
import type { SkedCaptionV2Props } from "./sked-caption-v2";

// Lazy load the SkedCaptionV2 component to reduce initial bundle size
// This component uses Lexical editor which is a heavy dependency
const LazySkedCaptionV2 = lazy(() =>
  import("./sked-caption-v2").then((module) => ({
    default: module.SkedCaptionV2,
  }))
);

// Skeleton loader that matches the SkedCaptionV2 dimensions
const SkedCaptionSkeleton = () => (
  <div className="relative">
    <div
      className="min-h-[108px] px-[12px] pt-[8px] pb-[32px] border border-neutral-100 rounded-[8px] bg-gray-50 animate-pulse"
      aria-label="Loading editor..."
    />
  </div>
);

/**
 * Lazy-loaded wrapper for SkedCaptionV2
 * Use this component instead of importing SkedCaptionV2 directly to improve bundle size
 */
export function SkedCaptionV2Lazy(props: SkedCaptionV2Props) {
  return (
    <Suspense fallback={<SkedCaptionSkeleton />}>
      <LazySkedCaptionV2 {...props} />
    </Suspense>
  );
}
